import { RouteState } from './helpers';

// The engagement page: /engagements/:workId, one path per tab, and /summaries/:documentId for one summary document.
// Every path is a child of one route, so moving between tabs only changes the URL: the page (and a live call on it)
// stays mounted. /work/... is not used because /work/:token is the public async-engagement form.

// Tab in the URL -> the page's section id. Tabs not listed (e.g. Vytal Insights extension tabs) use their id as is.
const TAB_SECTIONS = { summaries: 'summary', 'care-graph': 'careplan' };
const SECTION_TABS = Object.fromEntries(Object.entries(TAB_SECTIONS).map(([tab, section]) => [section, tab]));
export const DEFAULT_SECTION = 'assessments';

/** The page section a route shows. */
export function engagementSection(route) {
  if (route.name === 'ClinicalEngagementSummary') return 'summary';
  const tab = route.params.tab;
  if (!tab) return DEFAULT_SECTION;
  return TAB_SECTIONS[tab] || tab;
}

/** The summary document a route opens, or null. */
export function engagementDocumentId(route) {
  return route.name === 'ClinicalEngagementSummary' ? Number(route.params.documentId) : null;
}

/** Where an engagement's section (and, on Summaries, one document) lives. */
export function engagementLocation(workId, section = DEFAULT_SECTION, documentId = null) {
  if (section === 'summary' && documentId) {
    return { name: 'ClinicalEngagementSummary', params: { workId, documentId } };
  }
  if (!section || section === DEFAULT_SECTION) return { name: 'ClinicalEngagement', params: { workId } };
  return { name: 'ClinicalEngagementTab', params: { workId, tab: SECTION_TABS[section] || section } };
}

export function engagementRoutes(component) {
  return [
    {
      path: '/engagements/new/:opportunityId/:taskId',
      name: 'ClinicalEngagementNew',
      component,
      meta: { requiresAuth: true },
    },
    {
      path: '/engagements/:workId(\\d+)',
      component,
      meta: { requiresAuth: true },
      children: [
        { path: '', name: 'ClinicalEngagement', component: RouteState },
        { path: 'summaries/:documentId(\\d+)', name: 'ClinicalEngagementSummary', component: RouteState },
        { path: ':tab([a-z0-9_-]+)', name: 'ClinicalEngagementTab', component: RouteState },
      ],
    },
    // The old URLs: bookmarks, open tabs and links already sent.
    {
      path: '/work/clinicalengagement/new/:opportunityId/:taskId',
      redirect: (to) => ({ name: 'ClinicalEngagementNew', params: to.params }),
    },
    {
      path: '/work/clinicalengagement/:workId(\\d+)',
      redirect: (to) => ({ name: 'ClinicalEngagement', params: to.params }),
    },
  ];
}
